import _startCase from 'lodash/startCase';

// Keep in sync with AnnualTruckInspectionReport::EQUIPMENT_FIELDS (roadsider-backend)
export const TRUCK_INSPECTION_EQUIPMENT_FIELDS = [
  'steering_axle_tires_tread',
  'all_other_tires_tread',
  'fenders_mud_guards',
  'dual_rear_wheels',
  'all_other_wheels_rims',
  'fasteners',
  'rim_welds',
  'spring_assembly',
  'suspension_parts',
  'headlights',
  'tail_lamps',
  'license_plate_lamp',
  'stop_lamps',
  'backup_lamps',
  'reflectors',
  'amber_emergency_lights',
  'turn_signals',
  'safe_loading',
  'hydraulic_rams_hoses_valves',
  'excessive_fluid_leaks',
  'wire_rope',
  'no_visible_fuel_leak',
  'fuel_tank_filler_cap_present',
  'fuel_tank_securely_attached',
  'frame_members',
  'tire_wheel_clearance',
  'no_exhaust_leaks',
  'exhaust_system_heat_damage_risk',
  'front_axle_beam_steering_components',
  'steering_wheel_free_play',
  'steering_column',
  'steering_gear_box',
  'pitman_arm',
  'power_steering',
  'ball_socket_joints',
  'tie_rods_drag_links',
  'nuts',
  'horn',
  'mirrors',
  'windshield_condition',
  'windshield_wipers',
  'safety_triangles_or_flares',
  'broom',
  'shovel',
  'absorbent',
  'fire_extinguisher_mounted',
  'tow_hitch',
];

const EQUIPMENT_FIELD_LABELS = {
  steering_axle_tires_tread: 'Steering axle tires / tread',
  all_other_tires_tread: 'All other tires / tread',
  fenders_mud_guards: 'Fenders / mud guards',
  dual_rear_wheels: 'Dual rear wheels',
  all_other_wheels_rims: 'All other wheels / rims',
  fasteners: 'Fasteners',
  rim_welds: 'Rim welds',
  spring_assembly: 'Spring assembly',
  suspension_parts: 'Cracked, broken, loose or missing parts',
  headlights: 'Headlights',
  tail_lamps: 'Tail lamps',
  license_plate_lamp: 'License plate lamp',
  stop_lamps: 'Stop lamps',
  backup_lamps: 'Backup lamps',
  reflectors: 'Reflectors (Rear, Front and Side)',
  amber_emergency_lights: 'Amber emergency lights',
  turn_signals: 'Turn signals',
  safe_loading:
    'Vehicle part(s) or condition such that the spare tire or any part of the load or dunnage CANNOT fall onto the roadway',
  hydraulic_rams_hoses_valves: 'Hydraulic rams, hoses, valves',
  excessive_fluid_leaks: 'Excessive fluid leaks',
  wire_rope: 'Wire rope',
  no_visible_fuel_leak: 'No visible fuel leak',
  fuel_tank_filler_cap_present: 'Fuel tank filler cap present',
  fuel_tank_securely_attached: 'Fuel tank securely attached',
  frame_members: 'Frame members',
  tire_wheel_clearance: 'Tire / wheel clearance',
  no_exhaust_leaks: 'No exhaust leaks',
  exhaust_system_heat_damage_risk:
    'NO part of exhaust system so located as would likely result in burning, charring or damaging the electrical wiring, fuel supply or any combustible part of the motor vehicle',
  front_axle_beam_steering_components:
    'Front Axle Beam & Steering Components other than Steering Column',
  steering_wheel_free_play: 'Steering wheel free play',
  steering_column: 'Steering column',
  steering_gear_box: 'Steering gear box',
  pitman_arm: 'Pitman arm',
  power_steering: 'Power steering',
  ball_socket_joints: 'Ball / socket joints',
  tie_rods_drag_links: 'Tie rods / drag links',
  nuts: 'Nuts',
  horn: 'Horn',
  mirrors: 'Mirrors',
  windshield_condition: 'Windshield – No cracks or vision impairment/reducing matter',
  windshield_wipers: 'Windshield wipers',
  safety_triangles_or_flares: 'Safety triangles or flares',
  broom: 'Broom',
  shovel: 'Shovel',
  absorbent: 'Absorbent',
  fire_extinguisher_mounted: 'Fire extinguisher mounted',
  tow_hitch: 'Tow hitch',
};

export const equipmentFieldLabel = (field) =>
  EQUIPMENT_FIELD_LABELS[field] ?? _startCase(field);

export const equipmentStatusKey = (field) => `${field}_status`;

export const equipmentRepairDateKey = (field) => `${field}_repair_date`;

export const formatEquipmentStatus = (status) => {
  if (status === true) return 'OK';
  if (status === false) return 'Repair required';
  return '—';
};

export const GVWR_CLASS_LABELS = {
  regular: 'Regular',
  medium: 'Medium',
  heavy: 'Heavy',
};

export const URGENTLY_VEHICLE_TYPE_LABELS = {
  flat_bed: 'Flat bed',
  tow_truck: 'Tow truck',
  rsa: 'RSA',
  covered_carrier: 'Covered carrier',
};
